import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=e477fad4&scoped=true&"
var script = {}
import style0 from "./Share.vue?vue&type=style&index=0&id=e477fad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e477fad4",
  null
  
)

component.options.__file = "Share.vue"
export default component.exports